export default __webpack_public_path__ + "media/images/landing-1-2550c0e4e941133dceb6c9c705306593.png";